export default __webpack_public_path__ + "static/media/ae2817f377aac684c4dde33a33064f381601930997939.1fbefda2.webp";